import React from "react";
import "../css/home.css";
import Basefooter from "./Basefooter";
import Baseheader from "./Baseheader";
const home = () => {
  return (
    <div className="homebody">
      <Baseheader />
      <div className="main-homebody">
        <h3 className="main-slogan">The Place To Write Your life Story </h3>
        <section class="slider">
          <div class="carousel">
            <div class="slide fig1"></div>
            <div class="slide fig2"></div>
            <div class="slide fig3"></div>
            <div class="slide fig1"></div>
          </div>
        </section>
        <div className="sub-slogan">
          <h3 className="main-sub-slogan">
            Diary writing helps me get to the heart of the problem and flesh it
            out. I can work through issues by feeling free to write out the
            thoughts. It is a relief and a release.
          </h3>
        </div>
      </div>
      <Basefooter />
    </div>
  );
};
export default home;
